import { MapUiTheme } from '../../common';
import { padding } from '../../common/theme/utils';

export const selectTheme = {
  defaultStyles: (theme: MapUiTheme) => ({
    minHeight: 'none',
    borderRadius: 8,
    border: `1px solid ${theme.colors.neutral500}`,
  }),
  defaultStylesContainer: (theme: MapUiTheme) => ({
    fontSize: theme.fontSize.base,
    lineHeight: theme.lineHeight.select,
    color: theme.colors.text300,
  }),
  isDisabled: (theme: MapUiTheme) => ({
    borderColor: theme.colors.neutral400,
    color: theme.colors.neutral300,
  }),
  isCompleted: (theme: MapUiTheme) => ({
    borderColor: theme.colors.success200,
  }),
  isVerified: (theme: MapUiTheme) => ({
    borderColor: theme.colors.success200,
  }),
  isInvalid: (theme: MapUiTheme) => ({
    borderColor: theme.colors.danger300,
  }),
  xs: (theme: MapUiTheme) => ({
    ...padding(theme.spacing[0], theme.spacing[2]),
    height: `calc(${theme.spacing['2']} * 2 + ${theme.lineHeight.select})`,
    fontSize: theme.fontSize.sm,
  }),
  sm: (theme: MapUiTheme) => ({
    ...padding(theme.spacing[0], theme.spacing[3]),
    height: `calc(${theme.spacing['2']} * 2 + ${theme.lineHeight.select})`,
    fontSize: theme.fontSize.base,
  }),
  md: (theme: MapUiTheme) => ({
    ...padding(theme.spacing[0], theme.spacing[3]),
    height: `calc(${theme.spacing['3']} * 2 + ${theme.lineHeight.select})`,
    fontSize: theme.fontSize.base,
  }),
  lg: (theme: MapUiTheme) => ({
    ...padding(theme.spacing[0], theme.spacing[4]),
    height: `calc(${theme.spacing['4']} * 2 + ${theme.lineHeight.select})`,
    fontSize: theme.fontSize.base,
  }),
  xl: (theme: MapUiTheme) => ({
    ...padding(theme.spacing[0], theme.spacing[5]),
    height: `calc(${theme.spacing['5']} * 2 + ${theme.lineHeight.select})`,
    fontSize: theme.fontSize.base,
  }),
};
